<template>
    <div>
    <button class="btn btn-primary mb-1" v-on:click="addSalaryRow()" v-if="editMode" >
        <i class="icon-plus icons mr-1"/>Lägg till löneartrad
    </button>
    <b-card no-body class="mb-2"> 
        <table class="table table-striped mb-0 d-sm-none">
            <thead>
                <tr class="d-flex">
                <th class="col-5">Benämning</th>
                <th class="col-3">Datum</th>
                <th class="col-4 text-right">Belopp</th>
                </tr>
            </thead>
            <tbody>
                <tr class="d-flex" v-for="row in salarySpecification.salaryRows" :key="row.id">
                <td class="col-5">
                    {{row.definition}}
                    <span v-if="row.comment">
                    <br>
                    <small>
                        <i>{{row.comment}}</i>
                    </small>
                    </span>
                <td class="col-3"><span v-if="row.startDate">{{row.startDate | moment("YYMMDD") }}-{{row.endDate | moment("YYMMDD") }}</span></td>
                <td class="col-4 text-right"><span v-if="row.sum">{{row.sum | currency}}</span></td>
                </tr>  
            </tbody>
        </table>
        <table class="table table-borderless table-striped mb-0 d-none d-sm-block" v-if="salarySpecification">
            <thead>
                <tr style="border-bottom: 1px solid lightgray !important">
                <th style="width:1%"></th>
                <th style="width:3%" class="text-right">Löneart</th>
                <th>Benämning</th>
                <th style="width:20%">Datum</th>
                <th style="width:5%" class="text-right">Kvantitet</th>
                <th style="width:5%">Enhet</th>
                <th style="width:10%">À-pris</th>
                <th style="width:15%" class="text-right">Belopp</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in salarySpecification.salaryRows" :key="row.id" 
                    v-bind:class="{ 'editable': row.isManual && editMode}" v-bind:style="{'cursor:pointer' : row.isManual && editMode}"
                    class="rowborder" v-on:click="editClicked(row)">
                    <td>
                        <i class="icon-info icons" style="cursor:pointer" v-if="row.haveCalculationData && !editMode" v-on:click.stop="showCalculationData(row)"/>
                        <i class="cui-trash icons" style="cursor:pointer" v-if="editMode" v-on:click.stop="deleteRow(row)"/>
                    </td>
                    <td class="text-right">{{row.definitionId}}</td>
                    <td>
                        {{row.definition}}
                        <span v-if="row.comment">
                        <br>
                        <small>
                            <i>{{row.comment}}</i>
                        </small>
                        </span>
                    </td>
                    <td>
                        <span v-if="row.startDate">{{row.startDate | moment("YYYY-MM-DD") }} - {{row.endDate | moment("YYYY-MM-DD") }}</span>
                    </td>
                    <td class="text-right">{{row.quantity}}</td>
                    <td>{{units[row.unit]}}</td>
                    <td v-if="row.pricePerUnit">{{row.pricePerUnit | currency}}</td>
                    <td v-if="!row.pricePerUnit"></td>
                    <td class="text-right"><span v-if="row.sum && !row.isBenefit">{{row.sum | currency}}</span><span v-if="row.sum && row.isBenefit">({{row.sum | currency}})</span></td>
                </tr>
            </tbody>
        </table>
        <EditSalaryRowDialog ref="editSalaryRowDialog" :salaryRow="selectedSalaryRow" :salarySpecificationId="salarySpecification.id" 
            @onSalaryRowSaved="onSalaryRowSaved" @onLoading="onLoading"/>
        <CalculationInformationDialog ref="calculationInformationDialog" :salaryRow="selectedSalaryRow"/>
    </b-card> 
    </div>
</template>

<script>
import { salarySpecificationService } from "../../../shared/services";
import EditSalaryRowDialog from './EditSalaryRowDialog'
import CalculationInformationDialog from './CalculationInformationDialog'
export default {
    components: {
      EditSalaryRowDialog,
      CalculationInformationDialog
    },
    data() {
        return {
            selectedSalaryRow: null,
            selectedSalaryRowForDelete : Object,
            calculationData: Object,
            units: [" ", "Timmar", "Dagar", "Kr", "Mil", "Kalenderdagar", "st"],
            confirmText: null
        };
    },    
    props: {
        salarySpecification: null,
        editMode: Boolean,
    },
    methods: {
        onSalaryRowSaved(salarySpecification) {
            this.$emit("onSalaryRowUpdated", salarySpecification);

        },
        showCalculationData(row) {
            this.$refs.calculationInformationDialog.show(row);
        },
        addSalaryRow() {
            this.selectedSalaryRow  = {
                id: 0,
                definitionId: null,
                definition: null,
                startDate: null,
                endDate: null,
                quantity: null,
                comment: '',
                unit: 0,
                sum: null,
            };

            this.$refs.editSalaryRowDialog.show();
        },
        editClicked(row) {
            if(!this.editMode || !row.isManual) return;
            this.selectedSalaryRow = row;
            this.$refs.editSalaryRowDialog.show(); 
        },
        deleteRow(row) {
            this.$bvModal.msgBoxConfirm(`Är du säker på att du vill radera löneraden '${row.definition}'`)
            .then(value => {
                if(!value) return;
                this.$emit("loading", true);
                salarySpecificationService.deleteSalaryRow(this.salarySpecification.id, row.id)
                .then(p => {
                    this.$emit("onSalaryRowUpdated", p);
                    this.ShowToast("Raderad", "Löneraden raderades", "success");
                    this.$emit("onLoading", false);         
                }).catch(() => {
                    this.ShowToast("Fel", "Ett okänt fel uppstod då löneraden skulle raderas", "danger");
                    this.$emit("onLoading", false);      
                })
            }).catch(() => { 
                this.ShowToast("Fel", "Ett okänt fel uppstod då löneraden skulle raderas", "danger");
                this.$emit("onLoading", false);   

                });

        },
        onLoading(loading) {
            this.$emit("onLoading", loading); 
        }
    }

}
</script>

<style >


</style>





